import React, { FunctionComponent } from 'react'
import { StyleSheet, Text, View, TextInput } from 'react-native';
import MyCheckbox from '../../MyCheckbox';
import MyText from '../../MyText';
import AnnexForm from '../AnnexForm';
import { AntDesign } from '@expo/vector-icons'; 
import css from '../../Style'
import { TouchableOpacity } from 'react-native-gesture-handler';

const AnnexVINonHazardous = (props) => {
    const [collapsed, setCollapsed] = React.useState(true);

    const [ozone, setOzone] = React.useState(props?.value?.ozone?.active??false);
    const [exhaust, setExhaust] = React.useState(props?.value?.exhaust?.active??false);

    const [ozoneData, setOzoneData] = React.useState(props?.value?.ozone?.data??{});
    const [exhaustData, setExhaustData] = React.useState(props?.value?.exhaust?.data??{});

    const [hasChecked, setHasChecked] = React.useState(false);

    React.useEffect(() => {
        setCollapsed(!props.checked);
    }, [props.checked]);
    
    React.useEffect(() => {
        onChange();
    }, [ozone, exhaust,
        ozoneData, exhaustData]);

    const onChange = () => {
        props.onChange({
            ozone: {
                active: ozone,
                data: ozoneData
            },
            exhaust: {
                active: exhaust,
                data: exhaustData
            },
        });
    }

    const Block = (check, setCheck, data, setData, label) => {
        return (<>
            <View style={styles.row}>
                <MyCheckbox onClick={() => {setCheck(prev => !prev);}} checked={check} label={label} isInfo={props.isInfo}/>
            </View>
            {
                check && 
                <View style={[styles.row]}>
                    <AnnexForm wasteMetrics={props.wasteMetrics} onChange={setData} value={data} isInfo={props.isInfo}/>
                </View>
            }
        </>);
    }

    return (
        <View style={styles.annexContainer}>
            <TouchableOpacity activeOpacity={0.7} onPress={() => {setCollapsed(prev => !prev)}}>
                <MyText style={[styles.annexTitle, hasChecked?css.bold:css.normal]}>ANNEX VI - Related</MyText>
                <View style={{position: 'absolute', right: 10, top: 14}}>
                    <AntDesign name="down" size={12} color="#461b6f" style={{transition: 'all 0.3s linear', transform: [{rotate: collapsed?'0deg':'180deg'}]}}/>
                </View>
            </TouchableOpacity>
            <View style={styles.formContainer}>
                <View style={{display: collapsed?'none':'flex'}}>
                    {Block(ozone, setOzone, ozoneData, setOzoneData, 'Ozone depleting substances and equipment containing such substances')}
                    {Block(exhaust, setExhaust, exhaustData, setExhaustData, 'Exhaust Gas - Cleaning residues')}
                </View>
            </View>
        </View>
    )
}
const styles = StyleSheet.create({
    annexContainer: {
        marginBottom: 0
    },
    annexTitle: {
        backgroundColor: '#e9e3f0',
        color: '#57307e',
        textAlign: 'center',
        width: '100%',
        padding: 10
    },
    formContainer: {
        padding: 20,
        paddingTop: 15,
        paddingVertical: 0,
        flex: 1
    },
    row: {
        marginBottom: 15
    }
})
export default AnnexVINonHazardous